var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAirsupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.429,
    height: 25.84,
    viewBox: "0 0 21.429 25.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-455.307 -252.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M482.742,332.339s3.811-2.228,5.1-3c1.352-.814.4-3.4-1.19-2.493s-6.572,4.023-6.572,4.023",
    transform: "translate(-17.824 -54.569)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M470.689,321.92s3.811-2.228,5.1-3c1.352-.813.4-3.4-1.19-2.493s-5.382,3.343-5.382,3.343",
    transform: "translate(-9.737 -46.812)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M458.232,311.81s2.055-1.208,3.343-1.983c1.352-.814.4-3.4-1.19-2.493s-4.249,2.606-4.249,2.606",
    transform: "translate(0 -40.046)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 1.416,
    y2: 0.85,
    transform: "translate(461.575 269.782)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 1.36,
    y2: 0.963,
    transform: "translate(466.051 272.105)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M510.451,291.436l2.153,1.416,3.966-2.266v-6.062l-.453-.453L516,279.312l-5.326-3.569",
    transform: "translate(-40.434 -16.669)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M470.6,273.9l-.057-4.816,1.756-5.326L474.965,262l.907.567",
    transform: "translate(-10.727 -6.437)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M492.174,253.351v4.964c0,1.3,1.1,1.561,2.625,1.561s2.185-.633,2.185-1.369v-4.589",
    transform: "translate(-26.828)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M518.21,303.162v-6.6l.85-5.666,2.72-1.19",
    transform: "translate(-46.21 -27.066)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x1: 11.275,
    y1: 6.516,
    transform: "translate(461.575 257.317)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirsupply);
export default __webpack_public_path__ + "static/media/Icon-Air supply.3e0d5bbb0a5723b2c90e3f1c1d1c0887.svg";
export { ForwardRef as ReactComponent };